import { render, staticRenderFns } from "./exportTb.vue?vue&type=template&id=4fde3655&scoped=true&"
import script from "./exportTb.vue?vue&type=script&lang=js&"
export * from "./exportTb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde3655",
  null
  
)

export default component.exports